import { render, staticRenderFns } from "./muokkaa-tyoskentelyjaksoa.vue?vue&type=template&id=03165372&scoped=true&"
import script from "./muokkaa-tyoskentelyjaksoa.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-tyoskentelyjaksoa.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-tyoskentelyjaksoa.vue?vue&type=style&index=0&id=03165372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03165372",
  null
  
)

export default component.exports